export default "/images/Doximity.png?2ad99730a187818c41d6df7aaa7cfdbb";